<template lang="">
  <div>
    <el-dialog
      title="查看详情"
      :visible.sync="dialogVisible"
      width="1200px"
      :close-on-click-modal="false"
    >
      <WmsTable
        :hasHeader="false"
        :isPagination="query"
        :dataSource="dataSource"
        :columns="columns"
        @pageChange="pageChangeCall"
      ></WmsTable>
    </el-dialog>
  </div>
</template>
<script>
import WmsTable from "@/components/WmsTable";
import { getPickByBatchCode } from "@/apis/outStock";
export default {
  components: { WmsTable },
  data() {
    return {
      dialogVisible: false,
      batchCode: "",
      query: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      dataSource: [],
      columns: [
        {
          title: "批次",
          dataIndex: "pkgCode",
          key: "pkgCode",
        },
        {
          title: "数量",
          dataIndex: "nums",
          key: "nums",
        },
        {
          title: "库区",
          dataIndex: "regionName",
          key: "regionName",
        },
        {
          title: "库位",
          dataIndex: "gridCode",
          key: "gridCode",
        },
        {
          title: "拣货时间",
          dataIndex: "pickTime",
          key: "pickTime",
        },
      ],
    };
  },
  methods: {
    open(batchCode) {
      this.dialogVisible = true;
      this.batchCode = batchCode;
      this.query.current = 1
      this.query.total = 0
      this.getList()
    },
    getList() {
      getPickByBatchCode({
        batchCode: this.batchCode,
        ...this.query,
        pageNum: this.query.current
      }).then(res => {
        if(res.code == 0){
          this.dataSource = res.data.records
          this.query.total = res.data.total
        }
      });
    },
    pageChangeCall(payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getList();
    },
  },
};
</script>
<style scoped>
::v-deep .el-form-item__content {
  text-align: left;
}
::v-deep .el-input {
  width: 200px;
}
</style>
